import {
  Box,
  Button,
  CurrencyInput,
  Grid,
  IconButton,
  TextField,
  TextFieldMedidas,
  Tooltip,
} from "../../../components";
import { value } from "../../../helpers";
import { formatPrice, unformatPrice } from "../../../utils";
import { useEffect, useState } from "react";
import ProdutoSimilarDialog from "./dialog/produto/produto-similar.component";
import { notification } from "../../../services";
import { montarItem } from "../../../entities/pdv";
import DocumentoProdutoAplicacaoDialog from "./dialog/produto/documento-produto-aplicacao-dialog.component";

const PdvProdutoView = ({
  produto,
  setProduto,
  item,
  setItem,
  handleAdicionarProduto,
  isProdutoEdit,
  listaProdutosSimilares,
  setListaProdutosSimilares,
  unidadeList,
  origensMercadoriasList,
  permissoesHelper
}) => {
  const [openProdutoSimilarDialog, setOpenProdutoSimilarDialog] =
    useState(false);
  const [openProdutoAplicacoesDialog, setOpenProdutoAplicacoesDialog] =
    useState(false);
  const produtosColunasSimilares = [
    {
      field: "codigo",
      headerName: "Cod.",
      flex: 280,
    },
    {
      field: "descricao",
      headerName: "Produtos",
      flex: 700,
    },
    {
      field: "estoqueAtual",
      headerName: "Estoque",
      flex: 350,
    },
    {
      field: "precoVenda",
      headerName: "Preço Venda",
      flex: 500,
      valueGetter: (params) => formatPrice(params.value),
    },
    {
      field: "acoes",
      sortable: false,
      disableClickEventBubbling: true,
      renderHeader: () => {
        return (
          <i
            className="ph-fill ph-note-pencil"
            style={{ fontSize: 20, marginLeft: 14 }}
          ></i>
        );
      },
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              if (params.row) {
                setOpenProdutoSimilarDialog(false);
                setListaProdutosSimilares([]);
                handleChangeAutocompleteProdutoSimilar(params.row);
              }
            }}
            sx={{
              "&:hover": { backgroundColor: "transparent" },
            }}
          >
            <i
              className="ph-fill ph-paper-plane-right"
              style={{ fontSize: 20, marginLeft: 14 }}
            ></i>
          </IconButton>
        );
      },
    },
  ];

  useEffect(() => {
    if (produto) {
      document.getElementById("buttonAdicionar").focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (e) => {
    setItem((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleInputBlur = (e) => {
    setItem((prevState) => ({
      ...prevState,
      [e.target.name]: unformatPrice(e.target.value),
    }));
  };

  const openAplicacoesDialog = () => {
    if (produto === null) {
      notification.alertaGenericos(
        "Selecione um produto primeiro para colocar produto similar"
      );
    } else {
      setOpenProdutoAplicacoesDialog(true);
    }
  };

  const openProdutoSimilar = () => {
    if (produto === null) {
      notification.alertaGenericos(
        "Selecione um produto primeiro para colocar produto similar"
      );
    } else {
      setOpenProdutoSimilarDialog(true);
    }
  };

  const handleChangeAutocompleteProdutoSimilar = (produtoEscolhido) => {
    const unidadeProduto = unidadeList.find(
      (unidade) => unidade.id == produtoEscolhido.unidadeComercialVendaId
    );
    const tributosIcmsOrigem = origensMercadoriasList.find(
      (item) => item.id == produtoEscolhido.origemMercadoriaId
    )?.codigo;
    const itemTemp = montarItem(
      produto,
      {
        ...produtoEscolhido,
        unidadeProduto,
        tributosIcmsOrigem,
      },
      item.quantidade,
      true
    );
    setProduto(produtoEscolhido);
    setItem(itemTemp);
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className="d-flex gap-3 align-items-center">
            <h4 className="text-uppercase" style={{ fontWeight: 700 }}>
              {`${produto.codigo} - ${produto.descricao}`}
            </h4>
            {produto?.aplicacoes?.length ? (
              <Tooltip title="Aplicações do item" placement="bottom">
                <Button
                  id="buttonAplicacoesItem"
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{
                    height: "35px",
                    borderRadius: "20%",
                    minWidth: "15px",
                    boxShadow: "none",
                  }}
                  onClick={() => openAplicacoesDialog()}
                >
                  <i
                    className="ph-fill ph-circles-three"
                    style={{ color: "#fff", fontSize: 15 }}
                  ></i>
                </Button>
              </Tooltip>
            ) : null}

            {listaProdutosSimilares?.length ? (
              <Tooltip title="Consultar Similares" placement="bottom">
                <Button
                  id="buttonSimilarItem"
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{
                    height: "35px",
                    borderRadius: "20%",
                    minWidth: "15px",
                    boxShadow: "none",
                  }}
                  onClick={openProdutoSimilar}
                >
                  <i
                    className="ph-bold ph-approximate-equals"
                    style={{ color: "#fff", fontSize: 15 }}
                  ></i>
                </Button>
              </Tooltip>
            ) : null}
          </div>

          <hr className="mt-4" />
        </Grid>
      </Grid>

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={2}>
          <Tooltip title="Unidade de venda" placement="bottom">
            <TextField
              id="unidade"
              name="unidade"
              label="Unidade"
              variant="outlined"
              margin="normal"
              InputLabelProps={{ shrink: true }}
              value={item?.unidade ? item.unidade : ""}
              onChange={handleInputChange}
              disabled={true}
              fullWidth
            />
          </Tooltip>
        </Grid>
        <Grid item xs={2}>
          {item?.fracionavel ? (
            <TextFieldMedidas
              id="quantidade"
              name="quantidade"
              label="Quantidade"
              variant="outlined"
              margin="normal"
              shrink
              decimalScale={3}
              value={value.text(item?.quantidade)}
              onBlur={handleInputBlur}
            />
          ) : (
            <TextField
              id="quantidade"
              name="quantidade"
              label="Quantidade"
              variant="outlined"
              margin="normal"
              type="number"
              InputProps={{ inputProps: { min: 1, step: 1 } }}
              value={value.text(item?.quantidade)}
              onInput={(e) => {
                if (e.target.value <= 0) e.target.value = "";
                e.target.value = Math.trunc(Number(e.target.value));
                handleInputChange(e);
              }}
              onBlur={(e) => {
                if (
                  parseInt(e.target.value) === 0 ||
                  e.target.value === "" ||
                  e.target.value === null
                ) {
                  setItem((prev) => ({ ...prev, quantidade: 1 }));
                }
              }}
              required
              fullWidth
            />
          )}
        </Grid>
        <Grid item xs={3}>
          <CurrencyInput
            id="valor"
            name="valor"
            label="Valor Unitário R$"
            value={item?.valor}
            variant={"outlined"}
            onBlur={handleInputBlur}
            disabled={!permissoesHelper.temPermisao("alteracao-preco-venda")}
          />
        </Grid>
        <Grid item xs={3}>
          <CurrencyInput
            id="subTotal"
            name="subTotal"
            label="Total Item R$"
            variant="outlined"
            disabled={true}
            value={value.text(item?.valor * item?.quantidade)}
            onBlur={handleInputBlur}
          />
        </Grid>
        <Grid item xs={2}>
          <Tooltip title="Quantidade em estoque" placement="bottom">
            <TextField
              id="estoque"
              name="estoque"
              label="Estoque"
              variant="outlined"
              margin="normal"
              InputLabelProps={{ shrink: true }}
              value={item?.estoqueAtual ? item.estoqueAtual : 0}
              disabled={true}
            />
          </Tooltip>
        </Grid>
      </Grid>
      <Grid container spacing={2} alignItems="center" className="mt-1">
        <Grid item xs={4}>
          <hr />
        </Grid>
        <Grid item xs={4}>
          {isProdutoEdit ? (
            <Button
              id="buttonAdicionar"
              variant="contained"
              size="small"
              fullWidth
              sx={{
                height: "60px",
                borderRadius: "10px",
                boxShadow: "none",
              }}
              onClick={() => handleAdicionarProduto(produto, item)}
            >
              <i
                className="ph-bold ph-arrows-clockwise"
                style={{ color: "#fff", fontSize: 20, marginRight: 10 }}
              ></i>
              <span style={{ margin: 5, fontSize: 10 }}>ATUALIZAR PRODUTO</span>
            </Button>
          ) : (
            <Button
              id="buttonAdicionar"
              variant="contained"
              color="success"
              size="small"
              fullWidth
              sx={{
                height: "60px",
                borderRadius: "10px",
                boxShadow: "none",
              }}
              onClick={() => handleAdicionarProduto(produto, item)}
            >
              <i
                className="ph-fill ph-plus-circle"
                style={{ color: "#fff", fontSize: 20, marginRight: 10 }}
              ></i>
              <span style={{ margin: 5, fontSize: 10 }}>ADICIONAR PRODUTO</span>
            </Button>
          )}
        </Grid>
        <Grid item xs={4}>
          <hr />
        </Grid>
      </Grid>
      <DocumentoProdutoAplicacaoDialog
        open={openProdutoAplicacoesDialog}
        setOpen={setOpenProdutoAplicacoesDialog}
        aplicacoesProduto={produto?.aplicacoes}
      />
      <ProdutoSimilarDialog
        produto={produto}
        openProdutoSimilarDialog={openProdutoSimilarDialog}
        setOpenProdutoSimilarDialog={setOpenProdutoSimilarDialog}
        produtosColunasSimilares={produtosColunasSimilares}
        listaProdutosSimilares={listaProdutosSimilares}
      />
    </Box>
  );
};

export default PdvProdutoView;
